import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { Col } from 'react-bootstrap';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Flex } from 'antd';
import { formatDate, isValidDate } from '../../utils';

const iconsMap: Record<string, IconDefinition> = {
  dataset: solid('database'),
  model: solid('graduation-cap'),
  batch: solid('code'),
  service: solid('code'),
  agent: solid('user-secret'),
  mcp: solid('hand-sparkles'),
}

type Props = {
  title: string;
  name?: string;
  type: string;
  version?: string;
  trailing?: string;
  vertical?: boolean;
}

function NodeContent({ title, type, version, trailing, vertical }: Props) {
  return (
    <Flex align="center">
      <FontAwesomeIcon icon={iconsMap[type] || solid('cog')} />
      <Col className="overflow-hidden">
        <Flex align="center" vertical={vertical}>
          <Col className="px-2 overflow-hidden">
            <div className="node-title text-truncate">{title}</div>
          </Col>
          <div>
            {trailing && (
              <small className="node-trailing text-truncate">{isValidDate(trailing) ? formatDate(trailing) : trailing}</small>
            )}
            {version && (
              <small className="node-trailing text-truncate">
                <FontAwesomeIcon icon={solid('tag')} />
                <span className="ms-2">{version}</span>
              </small>
            )}
          </div>
        </Flex>
      </Col>
    </Flex>
  )
}

export default memo(NodeContent);
